import { render, staticRenderFns } from "./UniversityAboutInfo.vue?vue&type=template&id=5f46ef34"
import script from "./UniversityAboutInfo.vue?vue&type=script&lang=js"
export * from "./UniversityAboutInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports